export default "__VITE_ASSET__D9W8tWKB__"